import { EventEmitter, inject, Injectable } from '@angular/core';
import { ActionButton } from 'gung-common';
import { AuthService, Order } from 'gung-standard';
import { JeevesOrderActionConfigService } from 'gung-standard-jeeves';
import { Observable, map, switchMap } from 'rxjs';
import { OttoOlsenClaimModalComponent } from '../components/otto-olsen-claim-modal/otto-olsen-claim-modal.component';

@Injectable({
  providedIn: 'root'
})
export class OttoOlsenOrderActionConfigService extends JeevesOrderActionConfigService {
  protected authService = inject(AuthService);

  base = [
    { title: 'XLSX', action: (item: Order) => this.backendRerouteService.reroute('download/order-excel/' + item.id) },
    { title: 'PDF', action: (item: Order) => this.backendRerouteService.reroute('download/order-pdf/' + item.id) },
    // { title: 'IMAGES', action: (item: Order) => this.backendRerouteService.reroute('download/order-zip/' + item.id) },
    { title: 'COPY_TO_CART', action: (item: Order) => this.addOrderToCart(item) },
    { title: 'OTTO_OLSEN_SEARCH_CLAIM', action: (item: Order) => this.requestClaim(item) }
  ];

  getButtons(item: Order, eventEmitter?: EventEmitter<Order>): Observable<ActionButton<Order>[]> {
    return super.getButtons(item).pipe(
      switchMap(buttons =>
        this.authService.getRoles().pipe(
          map(roles => {
            const isSalesOrAdmin = roles.includes('SALES') || roles.includes('ADMIN');
            return isSalesOrAdmin ? buttons : buttons.filter(button => button.title !== 'OTTO_OLSEN_SEARCH_CLAIM');
          })
        )
      )
    );
  }

  protected requestClaim(order: Order) {
    const ref = this.modalService.open(OttoOlsenClaimModalComponent, {
      size: 'md',
      backdrop: 'static',
      keyboard: true,
      centered: true
    });

    ref.componentInstance.order = order;
  }
}
